import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { SimaTechProvider } from './components/Context';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <SimaTechProvider>
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  </SimaTechProvider>,
  rootElement);

registerServiceWorker();
